
export class UserInvitesBuilder {
    constructor() {
        this.userInvite = {};
    }

    setId(id){
        this.userInvite.id = id;
        return this;
    }

    setEmail(email){
        this.userInvite.email = email;
        return this;
    }

    setOrganizationName(organizationName){
        this.userInvite.organizationName = organizationName;
        return this;
    }

    setInvitedBy(invitedBy){
        this.userInvite.invitedBy = invitedBy;
        return this;
    }

    setRole(role){
        this.userInvite.role = role;
        return this;
    }

    setStatus(inviteStatus){
        this.userInvite.inviteStatus = inviteStatus;
        return this;
    }

    setDateCreated(dateCreated){
        this.userInvite.dateCreated = dateCreated;
        return this;
    }

    setActions(actions){
        this.userInvite.actions = actions;
        return this;
    }

    build(){
        return this.userInvite;
    }
}
